import { render } from "./FrameBuilder.vue?vue&type=template&id=5ebdf98e&scoped=true"
import script from "./FrameBuilder.vue?vue&type=script&lang=js"
export * from "./FrameBuilder.vue?vue&type=script&lang=js"

import "./FrameBuilder.vue?vue&type=style&index=0&id=5ebdf98e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebdf98e"]])

export default __exports__